<template>
<div>
<div v-if="!fieldType || fieldType == 'radio'">
	<div class="styled-radio-container styled-radio-container--ou-donation row">
		<div class="radio-part">
			<input id="oneTime" type="radio" class="frequency" :checked="!monthly" @click="setValue('dayOfMonth', null)"/>
			<FormLabel for="oneTime">One time</FormLabel>
		</div>
		<div class="radio-part">
			<input id="monthly" type="radio" class="frequency" :checked="monthly" @click="setValue('dayOfMonth', ''+new Date().getDate())"/>
			<FormLabel for="monthly">Monthly</FormLabel>		
		</div>
	</div>	
</div>
<FormCol field="Select Frequency" v-else-if="fieldType == 'dropdown'">
<select id="monthly" name="monthly" @change="setValue('dayOfMonth', $event.target.value)">   
  <option :value="null">One time donation</option>
  <option :value="''+new Date().getDate()">Monthly donation</option>
</select>
</FormCol>
<FormRow class="monthly-note" v-if="monthly && showMsg">
    <div v-if="lang == 'he'">
התרומה שלך תתבצע היום וב־<strong>{{monthDay}}</strong> של כל חודש לאחר מכן, באמצעות אמצעי התשלום שנבחר. ניתן לשנות או לבטל סכום זה בכל עת.
      <br/><br/>
    </div>      
    <div v-else>
      Your donation will be made today and on the <strong>{{monthDay}}</strong> of each following month using the payment method selected. You may change or cancel this amount at any time.
      <br/><br/>
    </div>    
</FormRow>
</div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  ref,
  watch,
  type PropType,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    	lang: {
      type: String
    },
    fieldType: {
      type: String,
      default: 'radio'
    },
    showMsg: {
      type: Boolean,
      default: true
    },
  },
  setup() {
    const { form, setValue } = usePaymentForm()

    return {
      monthly: computed(() => !!form.value.dayOfMonth),
      setValue,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!

        const j = i % 10,
          k = i % 100
        if (j == 1 && k != 11) {
          return i + 'st'
        }
        if (j == 2 && k != 12) {
          return i + 'nd'
        }
        if (j == 3 && k != 13) {
          return i + 'rd'
        }
        return i + 'th'
      }),
    }
  },
})
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6%;
      margin-bottom: 10px;
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}
</style>